// store/satisfaction.slice.ts
import { createSlice } from '@reduxjs/toolkit';

interface SatisfactionState {
  [key: string]: number | string;
}

const initialState: SatisfactionState = {
  // Initialize ratings as numbers, not strings
  ACCESS_FACILITY: 0,
  ERGONOMY: 0,
  SIMPLICITY: 0,
  INTUITIVENESS: 0,
  FIABILITY: 0,
  RAPIDITY: 0,
  LISIBILITY: 0,
  INFORMATIONS: 0,
  DESIGN: 0,
  
  // Radio options
  TOOL_GIVE_HELP_SATISFACTION: "1",
  GIVE_IT_HELP_SATISFACTION: "1",
  APP_IS_HELPFULL: "2",
  
  // Text fields
  GIVE_IT_HELP_PLUS_SATISFACTION: "",
  SUGGESTION: ""
};


const satisfactionSlice = createSlice({
  name: 'satisfaction',
  initialState,
  reducers: {
    updateField(state, action) {
      // debugger;
      const { field, value } = action.payload as { field: string; value: number | string };
      state[field] = value;
    },
    resetForm: () => initialState,
    submitForm: (/*state*/) => {
      // Reset form after submission
      return initialState;
    },
  },
});

export const { updateField, resetForm, submitForm } = satisfactionSlice.actions;
export default satisfactionSlice.reducer;
